var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bo-carousel"},[_c('div',{ref:"carousel",staticClass:"carousel"},_vm._l((_vm.images),function(image){return _c('a',{key:image.index,attrs:{"href":image.link}},[_c('img',{attrs:{"src":_vm.getUniqueParam(image.src)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }